module.exports = __webpack_public_path__ + "static/media/UP_L3.0d3e9a1c.svg";